import { GetterTree } from 'vuex'
import { StatisticState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<StatisticState, RootState> = {
    viberStatisticDetail: (state) => state.viberStatisticDetail,
    viberStatisticDetailFlag: (state) => state.viberStatisticDetailFlag,
    viberStatisticGroup: (state) => state.viberStatisticGroup,
    viberGroupBy: (state) => state.viberGroupings.viberGroup,
    viberGroupByOptionally: (state) => state.viberGroupings.viberGroupByOptionally,
};
